module.exports = __webpack_public_path__ + "/images/mockup_lista_general_ES.4105b29.png";